import { CreateProfilForm } from "./components/create-profil-form";
import { EditProfilForm } from "./components/edit-profil-form";

interface ProfilFormProps {
  id?: string;
  profilId?: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function ProfilForm({ id, profilId, onCancel, onSuccess }: ProfilFormProps) {
  // Check if we're in edit mode by looking for either id or profilId
  const isEditing = !!id || !!profilId;

  if (isEditing) {
    return (
      <EditProfilForm
        id={id || profilId?.toString() || ""}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    );
  }

  return (
    <CreateProfilForm
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
}
